import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalComponent } from '../../reusable-components/modal/modal.component';
import { AuthenticationService } from '../../services/authentication.service';
import { PersistenceService } from '../../services/persistence.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { RegistrationService } from 'src/app/services/registration.service';
import { ConstantsService } from 'src/app/services/constants.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    standalone: false
})
export class LogoutComponent implements OnInit {
attendee;
  constructor(
    private matDialog: MatDialog,
    private authService: AuthenticationService,
    private http: HttpClient,
    private persistenceService: PersistenceService,
    private router: Router,
    private registrationService: RegistrationService,
    private constantsService: ConstantsService,
  ) {
   }

   isUserLoggedIn(){
      return this.authService.authtoken !== undefined;
   }

  openModal() {
    const dialogConfig = new MatDialogConfig();


    dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component-logout";
    //dialogConfig.copy = "copy.label.LOGOUTMODULE.message";
    // dialogConfig.title = "Terms Of Use"
    dialogConfig.data = {
      name: "logout",
      title: "Are you sure you want to logout?",
      actionButtonText: "Logout",
    }
    if(this.registrationService.isRegistrationComplete()){
      dialogConfig.data.copy = 'copy.label.LOGOUTMODULE.rvsmessage'
    }else{
      dialogConfig.data.copy = 'copy.label.LOGOUTMODULE.message'
    }



    const modalDialog = this.matDialog.open(ModalComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((data) => {
      if(data === 'Logout'){
       // logging out
        this.logout();
      }
    });

  }
  logout() {
    this.attendee = this.registrationService.getAttendee({});
   // in logout function
    this.authService.invalidateSessionToken().then(() => {
     // after invalidateSessionToken
        //this.http.defaults.headers.common["MTC-Session-Token"] = undefined;
        this.persistenceService.clear();
        if(this.constantsService.paxLoginREDIRECTION.includes(this.attendee.PAXTypeNo)){
          this.router.navigate(['/login']);
        }else{
          this.router.navigate(['/instructions']);  
        }

      });
  };

  ngOnInit(): void {
  }
}
